import {Component, Input, OnInit} from '@angular/core';
import {PieceJointe} from '../services/pieces-jointes/piece-jointe.model';
import {FilePreviewModaleComponent} from '../file-preview-modale/file-preview-modale.component';
import { MatDialog } from '@angular/material/dialog';
import {PiecejointeService} from '../services/pieces-jointes/piecejointe.service';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.scss']
})
export class FilePreviewComponent implements OnInit {
  @Input() file: PieceJointe = null;

  constructor(private dialog: MatDialog,
              private pieceJointeService: PiecejointeService) { }

  ngOnInit() {
  }

  /**
   * Est-ce un PDF | PNG | JPG
   */
  canPreview() {
    if (this.file && this.file.filename) {
      const ext = this.file.filename.split('.').pop();
      if (ext && (ext.toLowerCase() === 'png' || ext.toLowerCase() === 'jpg' ||
        ext.toLowerCase() === 'jpeg' || ext.toLowerCase() === 'pdf')) {
        return true;
      }
    }
    return false;
  }

  /**
   * Preview image ou PDF
   */
  popUpPreviewImage() {
    if (this.file) {
      this.pieceJointeService.getFile(this.file.id).subscribe(data => {
        if (data) {
          this.popUp(data);
        }
      });
    }
  }

  popUp(_blob: any) {
    const dialogRef = this.dialog.open(FilePreviewModaleComponent, {
      data: _blob
    });
  }
}
